<div class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="header-area flex flex-row justify-start items-center">
    <button
      (click)="openManageMembersDialog()"
      class="link-button"
      [disabled]="!(dynamicData.card?.permissionLevel === 310 || dynamicData.card?.permissionLevel === 320)"
      data-copilot="task-assignee-btn-add-people"
      mat-button
    >
      Add People
    </button>
    <button *ngIf="!(isSupportBoard() && isClient)"
      (click)="assignToMe()"
      [disabled]="dynamicData.card?.permissionLevel < 310"
      class="link-button"
      data-copilot="task-assignee-btn-assign-to-me"
      mat-button
    >
      Assign to Me
    </button>
    <button *ngIf="dynamicData.board.name !== 'Grid Filter' && !(isSupportBoard() && isClient)"
            class="link-button"
            (click)="addNotificationsButtonClicked()"
            data-copilot="task-assignee-btn-add-notifications"
            mat-button
    >
      Add Notifications
    </button>
  </div>

  <div class="content pos-relative flex flex-col full-grow-no-shrink-no-basis">
    <div class="keno-grid-container">
      <particle-virtual-grid
        (valueChanged)="onGridCellValueChange($event)"
        [invalidateSubject]="invalidateSubject"
        [parameters]="parameters"
        [sourceKey]="sourceKey"
        [serviceName]="serviceName"
        [api]="api"
        version="v2"
        tabStyle="compact"
        [useSwitchMap]="1===1">
      </particle-virtual-grid>
    </div>
  </div>

  <!--  <button mat-button (click)="sentTaskNotification()"
            mat-button class="send-notification"
            [disabled]="sendNotificationButtonDisabled"
            particleAnalytics
            analyticsCategory="task-notification-send"
            analyticsAction="task-notification"><i class="far fa-share"></i> Send Notification
    </button>-->

</div>
